import Axios from "axios";
import {
    SET_ROLE_PERMISSION,
    UNSET_ROLE_PERMISSION
  } from "@/store/mutation-types";
import { saveRolePermission, getRolePermission  } from "@/store/api";
// initial state
const state = {
  getRolePermission: [],
};

const getters = {
  getRolePermission(state) {
    return state.getRolePermission;
  },
};
const mutations = {
  [SET_ROLE_PERMISSION](state, data) {
    state.getRolePermission = data;
  },
  [UNSET_ROLE_PERMISSION](state) {
    state.getRolePermission = [];
  },

};

const actions = {

  saveRolePermission({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveRolePermission, data)
        .then(function (response) {
          let menu_ind = response.data;
          if(menu_ind.hasOwnProperty('menu')){
            localStorage.setItem("menu", JSON.stringify(menu_ind.menu));
            commit('SET_USER_PERMISSION',menu_ind.menu);
          }
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getRolePermission({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getRolePermission, data)
        .then(function (response) {
          commit('SET_ROLE_PERMISSION',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_ROLE_PERMISSION')
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
